/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EnvironmentToxinsResponseDto,
  EnvironmentToxinsUpsertRequestDto,
  ErrorResponse,
} from '../models/index';
import {
    EnvironmentToxinsResponseDtoFromJSON,
    EnvironmentToxinsResponseDtoToJSON,
    EnvironmentToxinsUpsertRequestDtoFromJSON,
    EnvironmentToxinsUpsertRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface GetEnvironmentToxinsByPatientIdRequest {
    patientId: string;
}

export interface UpsertEnvironmentToxinsRequest {
    environmentToxinsUpsertRequestDto: EnvironmentToxinsUpsertRequestDto;
}

export interface UpsertEnvironmentToxinsByPatientIdRequest {
    patientId: string;
    environmentToxinsUpsertRequestDto: EnvironmentToxinsUpsertRequestDto;
}

/**
 * 
 */
export class PatientEnvironmentToxinsApi extends runtime.BaseAPI {

    /**
     * Get patient\'s environment toxins
     */
    async getEnvironmentToxinsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/environment-toxins`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s environment toxins
     */
    async getEnvironmentToxins(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.getEnvironmentToxinsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s environment toxins by patient ID
     */
    async getEnvironmentToxinsByPatientIdRaw(requestParameters: GetEnvironmentToxinsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getEnvironmentToxinsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/environment-toxins/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s environment toxins by patient ID
     */
    async getEnvironmentToxinsByPatientId(requestParameters: GetEnvironmentToxinsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.getEnvironmentToxinsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s environment toxins
     */
    async upsertEnvironmentToxinsRaw(requestParameters: UpsertEnvironmentToxinsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        if (requestParameters['environmentToxinsUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'environmentToxinsUpsertRequestDto',
                'Required parameter "environmentToxinsUpsertRequestDto" was null or undefined when calling upsertEnvironmentToxins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/environment-toxins`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EnvironmentToxinsUpsertRequestDtoToJSON(requestParameters['environmentToxinsUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s environment toxins
     */
    async upsertEnvironmentToxins(requestParameters: UpsertEnvironmentToxinsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.upsertEnvironmentToxinsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s environment toxins by patient ID
     */
    async upsertEnvironmentToxinsByPatientIdRaw(requestParameters: UpsertEnvironmentToxinsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertEnvironmentToxinsByPatientId().'
            );
        }

        if (requestParameters['environmentToxinsUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'environmentToxinsUpsertRequestDto',
                'Required parameter "environmentToxinsUpsertRequestDto" was null or undefined when calling upsertEnvironmentToxinsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/environment-toxins/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EnvironmentToxinsUpsertRequestDtoToJSON(requestParameters['environmentToxinsUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s environment toxins by patient ID
     */
    async upsertEnvironmentToxinsByPatientId(requestParameters: UpsertEnvironmentToxinsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.upsertEnvironmentToxinsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
